import React from 'react';
import './Header.css';
import { FaGithub } from 'react-icons/fa';
import { AiFillLinkedin } from 'react-icons/ai';
import { AiOutlineTwitter } from 'react-icons/ai';
import { AiOutlineInstagram } from 'react-icons/ai';

const Header = () => {
  return (
    <div className="container-header" id="header">
      <div className="main-social">
        <ul className="socials-list">
          <li>
            <a
              target="_blank"
              href="https://github.com/nicoalanis14"
              rel="noreferrer"
              alt="Github"
            >
              <FaGithub className="social-header" />
            </a>
          </li>
          <li>
            <a
              target="_blank"
              href="https://www.linkedin.com/in/nicolas-alanis-3314401bb/"
              rel="noreferrer"
              alt="Linkedin"
            >
              <AiFillLinkedin className="social-header" />
            </a>
          </li>
          <li>
            <a
              target="_blank"
              href="https://twitter.com/nicoalanis14  "
              rel="noreferrer"
              alt="Twitter"
            >
              <AiOutlineTwitter className="social-header" />
            </a>
          </li>
          <li>
            <a
              target="_blank"
              href="https://www.instagram.com/nico_alanis14/"
              rel="noreferrer"
              alt="Instagram"
            >
              <AiOutlineInstagram className="social-header" />
            </a>
          </li>
        </ul>
      </div>
      <div className="center-container">
        <h1 className="h1-header">
          Hi, I'm <br></br>
          <span className="nombre-span">Nicolas Alanis</span>
          <br></br>
          Front-End Developer
        </h1>
      </div>
    </div>
  );
};

export default Header;
